interface KeyCommandProps {
  className?: string
  children: string
  useSystemModifier?: boolean
}

export const KeyCommand: React.FC<KeyCommandProps> = (props) => {
  const { className = '', children, useSystemModifier = false } = props

  const getSystemModifier = () => {
    const platform =
      (navigator as any)?.userAgentData?.platform || (navigator as any)?.platform || 'unknown'
    const isMac = platform.toLowerCase().includes('mac')
    return isMac ? '⌘' : 'Ctrl'
  }

  return (
    <kbd
      className={`${className} inline-flex items-center font-medium pt-px px-1 text-xs bg-background-muted text-gray-500 rounded border border-border`}
    >
      {useSystemModifier && <span className="mr-1">{getSystemModifier()}</span>}
      <span>{children}</span>
    </kbd>
  )
}
